import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-heading',
  templateUrl: './main-heading.component.html',
})
export class MainHeadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
